import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Col,
  Container,
  Pagination,
  Row,
} from "react-bootstrap";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import ex_years from "../../../assets/images/icons/ex_years.png";
import degree from "../../../assets/images/icons/degree.png";
import $per_time from "../../../assets/images/icons/$per_time.png";
import language from "../../../assets/images/icons/language.png";
import { getCoaches } from "../../../utils/api";
import Pic from "../../../assets/images/icons/user.png";
import FrontFilterComponent from "./Filter";
import { getBadgeColor } from "../../../utils/functions";
import { followUnfollowCoach, getFilteredCoaches } from "../../../utils/api";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useUserContext } from "../../../utils/hooks/UserContext";
import { PulseLoader } from "react-spinners";
import LoginComponent from "../Login/index";
import { Helmet } from "react-helmet";
import banner from "../../../assets/images/coach_details_banner.png";

import experience from "../../../assets/images/icons/experience.png";
import coached from "../../../assets/images/icons/coached.png";
import earn from "../../../assets/images/icons/earn.png";
import Lottie from "react-lottie";
import noDataLottie from "../../../assets/lottieFiles/noData.json";
import CoachCard from "../../../components/CoachCard";
import { motion } from "framer-motion";

function BrowseCoachGridViewComponent() {
  const [coaches, setCoaches] = useState([]);
  const navigate = useNavigate();
  const { user } = useUserContext();
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loginModalShow, setLoginModalShow] = useState(false);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: noDataLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 9;

  // Filters State
  const [filters, setFilters] = useState({
    positions: [],
    specialities: [],
    languages: [],
    experience: { min: 0, max: 100 },
    cost: { min: 0, max: 100 },
  });

  useEffect(() => {
    getData();
    window.scrollTo(0, 0);
  }, [currentPage, filters]); // Fetch when page or filters change

  const getData = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();

      if (filters.positions.length > 0) {
        formData.append(
          "positions",
          JSON.stringify(filters.positions.map((i) => i.label))
        );
      }
      if (filters.specialities.length > 0) {
        formData.append(
          "specialities",
          JSON.stringify(filters.specialities.map((i) => i.value))
        );
      }
      if (filters.languages.length > 0) {
        formData.append(
          "languages",
          JSON.stringify(filters.languages.map((i) => i.value))
        );
      }
      // Only append experience & cost filters if they are changed from default
      if (filters.experience.min !== 0 || filters.experience.max !== 100) {
        formData.append("min_experience", filters.experience.min);
        formData.append("max_experience", filters.experience.max);
      }
      if (filters.cost.min !== 0 || filters.cost.max !== 100) {
        formData.append("min_cost", filters.cost.min);
        formData.append("max_cost", filters.cost.max);
      }

      // Pagination params
      formData.append("start", (currentPage - 1) * pageSize);
      formData.append("length", pageSize);

      const { data } = await getFilteredCoaches(formData);
      if (data?.status) {
        console.log("Filtered Coaches Data:", data?.data);
        let coache = data?.data;
        if (coache.length > 0) {
          const sortedData = coache.map((coach) => ({
            ...coach,
            programs: coach.programs?.slice().sort((a, b) => a.price - b.price),
          }));
          setCoaches(sortedData);
        }
        setCoaches(data?.data);
        setTotalPages(data?.pagination.totalPages || 1);
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (coaches.length > 0) {
      const sortedData = coaches.map((coach) => ({
        ...coach,
        programs: coach.programs?.slice().sort((a, b) => a.price - b.price),
      }));
      setCoaches(sortedData);
    }
  }, []);
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleFilterChange = (newFilters) => {
    const isEqual = JSON.stringify(newFilters) === JSON.stringify(filters);
    if (!isEqual) {
      setFilters(newFilters);
      setCurrentPage(1);
    }
  };
  
  // const handleFilterChange = (newFilters) => {
  //   setFilters(newFilters);
  //   setCurrentPage(1); // Reset page when filters change
  // };
  const removeHTMLTags = (str) => {
    if (str != null) {
      return str.replace(/<[^>]+>/g, "");
    }
  };
  const defaultUserImage = (e) => {
    e.target.src = Pic;
  };
  const onClickFollow = async (id) => {
    if (!user) {
      // navigate('/')
      setLoginModalShow(true);
      toast.error("Please login to do this action");
      return;
    }

    const formdata = new FormData();
    formdata.append("coach_id", id);

    await followUnfollowCoach(formdata);
    await getData();
  };
  const likeButton = async (e) => {
    if (!user) {
      setLoginModalShow(true);
      toast.error("Please login to do this action");
      return;
    }
  };
  return (
    <>
      <Helmet
        htmlAttributes={{ lang: "en" }}
        title="Explore Expert Coaches | Find Your Perfect Match on Qoach"
        meta={[
          {
            name: "description",
            content:
              "Explore top coaches in a convenient grid format. Find your perfect match for career, wellness, or personal development coaching. Start your journey to success with Qoach today!",
          },
        ]}
      />
      {loading ? (
        // <PulseLoader color="#36D7B7" loading={loading} size={15} />
        <div
          style={{
            // textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100vw",
          }}
        >
          <p>
            <PulseLoader color="#00504E" size={20} />
          </p>
        </div>
      ) : (
        <>
          <section className="pb-4 white_bg">
            <Container>
              <div className="flex flex-wrap mt-[106px] items-center justify-between">
                <Col>
                  <FrontFilterComponent
                    filters={filters}
                    setFilters={handleFilterChange}
                  />
                </Col>
                <Col sm="auto">
                  <Row className="g-2">
                    <Col>
                      <NavLink
                        className="list_grid_view_btn"
                        to="/browse-coach/list-view"
                      >
                        <svg
                          opacity="0.6"
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g>
                            <circle
                              cx="20"
                              cy="20"
                              r="18.5"
                              stroke="#964B00"
                              strokeWidth="3"
                            />
                            <path
                              d="M28.1751 14.3654V25.6333H11.8247V14.3654H28.1751ZM28.6751 12.041H11.3247C10.3169 12.041 9.5 12.8575 9.5 13.8654V26.1333C9.5 27.1412 10.3169 27.9582 11.3247 27.9582H28.6751C29.683 27.9582 30.5 27.1413 30.5 26.1333V13.8654C30.5 12.8574 29.6829 12.041 28.6751 12.041Z"
                              fill="#964B00"
                              stroke="#964B00"
                            />
                          </g>
                        </svg>
                      </NavLink>
                    </Col>
                    <Col>
                      <NavLink
                        className="list_grid_view_btn"
                        to="/browse-coach/grid-view"
                      >
                        <svg
                          opacity="0.6"
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="20"
                            cy="20"
                            r="18.5"
                            stroke="#964B00"
                            strokeWidth="3"
                          />
                          <g clipPath="url(#clip0_2115_3853)">
                            <path
                              d="M15.8333 10H13.3333C12.4493 10 11.6014 10.3512 10.9763 10.9763C10.3512 11.6014 10 12.4493 10 13.3333V15.8333C10 16.7174 10.3512 17.5652 10.9763 18.1904C11.6014 18.8155 12.4493 19.1667 13.3333 19.1667H15.8333C16.7174 19.1667 17.5652 18.8155 18.1904 18.1904C18.8155 17.5652 19.1667 16.7174 19.1667 15.8333V13.3333C19.1667 12.4493 18.8155 11.6014 18.1904 10.9763C17.5652 10.3512 16.7174 10 15.8333 10ZM17.5 15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H13.3333C12.8913 17.5 12.4674 17.3244 12.1548 17.0118C11.8423 16.6993 11.6667 16.2754 11.6667 15.8333V13.3333C11.6667 12.8913 11.8423 12.4674 12.1548 12.1548C12.4674 11.8423 12.8913 11.6667 13.3333 11.6667H15.8333C16.2754 11.6667 16.6993 11.8423 17.0118 12.1548C17.3244 12.4674 17.5 12.8913 17.5 13.3333V15.8333Z"
                              fill="#964B00"
                            />
                            <path
                              d="M26.6673 10H24.1673C23.2833 10 22.4354 10.3512 21.8103 10.9763C21.1852 11.6014 20.834 12.4493 20.834 13.3333V15.8333C20.834 16.7174 21.1852 17.5652 21.8103 18.1904C22.4354 18.8155 23.2833 19.1667 24.1673 19.1667H26.6673C27.5514 19.1667 28.3992 18.8155 29.0243 18.1904C29.6495 17.5652 30.0007 16.7174 30.0007 15.8333V13.3333C30.0007 12.4493 29.6495 11.6014 29.0243 10.9763C28.3992 10.3512 27.5514 10 26.6673 10ZM28.334 15.8333C28.334 16.2754 28.1584 16.6993 27.8458 17.0118C27.5333 17.3244 27.1093 17.5 26.6673 17.5H24.1673C23.7253 17.5 23.3014 17.3244 22.9888 17.0118C22.6762 16.6993 22.5007 16.2754 22.5007 15.8333V13.3333C22.5007 12.8913 22.6762 12.4674 22.9888 12.1548C23.3014 11.8423 23.7253 11.6667 24.1673 11.6667H26.6673C27.1093 11.6667 27.5333 11.8423 27.8458 12.1548C28.1584 12.4674 28.334 12.8913 28.334 13.3333V15.8333Z"
                              fill="#964B00"
                            />
                            <path
                              d="M15.8333 20.834H13.3333C12.4493 20.834 11.6014 21.1852 10.9763 21.8103C10.3512 22.4354 10 23.2833 10 24.1673V26.6673C10 27.5514 10.3512 28.3992 10.9763 29.0243C11.6014 29.6495 12.4493 30.0007 13.3333 30.0007H15.8333C16.7174 30.0007 17.5652 29.6495 18.1904 29.0243C18.8155 28.3992 19.1667 27.5514 19.1667 26.6673V24.1673C19.1667 23.2833 18.8155 22.4354 18.1904 21.8103C17.5652 21.1852 16.7174 20.834 15.8333 20.834ZM17.5 26.6673C17.5 27.1093 17.3244 27.5333 17.0118 27.8458C16.6993 28.1584 16.2754 28.334 15.8333 28.334H13.3333C12.8913 28.334 12.4674 28.1584 12.1548 27.8458C11.8423 27.5333 11.6667 27.1093 11.6667 26.6673V24.1673C11.6667 23.7253 11.8423 23.3014 12.1548 22.9888C12.4674 22.6762 12.8913 22.5007 13.3333 22.5007H15.8333C16.2754 22.5007 16.6993 22.6762 17.0118 22.9888C17.3244 23.3014 17.5 23.7253 17.5 24.1673V26.6673Z"
                              fill="#964B00"
                            />
                            <path
                              d="M26.6673 20.834H24.1673C23.2833 20.834 22.4354 21.1852 21.8103 21.8103C21.1852 22.4354 20.834 23.2833 20.834 24.1673V26.6673C20.834 27.5514 21.1852 28.3992 21.8103 29.0243C22.4354 29.6495 23.2833 30.0007 24.1673 30.0007H26.6673C27.5514 30.0007 28.3992 29.6495 29.0243 29.0243C29.6495 28.3992 30.0007 27.5514 30.0007 26.6673V24.1673C30.0007 23.2833 29.6495 22.4354 29.0243 21.8103C28.3992 21.1852 27.5514 20.834 26.6673 20.834ZM28.334 26.6673C28.334 27.1093 28.1584 27.5333 27.8458 27.8458C27.5333 28.1584 27.1093 28.334 26.6673 28.334H24.1673C23.7253 28.334 23.3014 28.1584 22.9888 27.8458C22.6762 27.5333 22.5007 27.1093 22.5007 26.6673V24.1673C22.5007 23.7253 22.6762 23.3014 22.9888 22.9888C23.3014 22.6762 23.7253 22.5007 24.1673 22.5007H26.6673C27.1093 22.5007 27.5333 22.6762 27.8458 22.9888C28.1584 23.3014 28.334 23.7253 28.334 24.1673V26.6673Z"
                              fill="#964B00"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2115_3853">
                              <rect
                                width="20"
                                height="20"
                                fill="white"
                                transform="translate(10 10)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </NavLink>
                    </Col>
                  </Row>
                </Col>
              </div>
              <Row className="">
                <Col>
                  <div className="mt-10 browse_coach_grid_list_card">
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 ">
                      {coaches?.map((coach, index) => (
                        <motion.div
                          key={coach.coach_id}
                          className="h-full"
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{
                            delay: index * 0.1, // Staggered delay based on index
                            duration: 0.3,
                            type: "spring",
                            stiffness: 100,
                          }}
                          whileHover={{ scale: 1.03 }}
                        >
                          <CoachCard
                            coach={coach}
                            user={user}
                            likeButton={likeButton}
                            defaultUserImage={defaultUserImage}
                          />
                        </motion.div>
                      ))}
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          {coaches && coaches.length !== 0 ? (
            <Container className="mb-4 text-center">
              <Pagination className="justify-content-center">
                <Pagination.Prev
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                />

                {[...Array(totalPages)].map((_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}

                <Pagination.Next
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                />
              </Pagination>
            </Container>
          ) : (
            <Col>
              <Lottie
                options={defaultOptions}
                height={300}
                width={400}
                isStopped={false}
                isPaused={false}
              />
            </Col>
          )}
        </>
      )}
    </>
  );
}

export default BrowseCoachGridViewComponent;
